import AccountStatementPDF from 'features/statementsAndForms/screens/AccountStatements/AccountStatementPdf';
import React from 'react';

export default function AccountStatementsSelectedMonthPage() {
  return <AccountStatementPDF />;
}
